import { useMutation } from "@tanstack/react-query";
import api from "apis";

const useNoticeDeleteMutation = () => {
  return useMutation({
    mutationFn: api.notice.deleteNotice,
  });
};

export default useNoticeDeleteMutation;
